import {msg} from '@lit/localize';
import {css, html, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {connect} from 'pwa-helpers';
import {selectPersonalisation} from '../../selectors';
import store from '../../store';

@customElement('personalise-form')
export class PersonaliseForm extends connect(store)(LitElement) {

	static styles = css`
		.form {
			width: 69%;
			margin-left: auto;
			display: flex;
			flex-direction: column;
			gap: 3cqw;
			container-type: inline-size;
		}
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.personalisation = selectPersonalisation(state);
		this.print = state.status.media === 'print' || status.media === 'print2';
	}

	connectedCallback() {
		super.connectedCallback();
	}

	render() {
		const p = this.personalisation;
		return html`
			<div class="form ${classMap({print: this.print})}">
				<personalise-field label=${msg('Company')} name="company" value="${p.company}"
								   ?print="${this.print}"></personalise-field>
				<personalise-field label=${msg('Contact')} name="contact" value="${p.contact}"
								   ?print="${this.print}"></personalise-field>
				<personalise-field label=${msg('Phone')} name="phone" value="${p.phone}"
								   ?print="${this.print}"></personalise-field>
				<personalise-field label=${msg('E-Mail')} name="email" value="${p.email}"
								   ?print="${this.print}"></personalise-field>
				<personalise-field label=${msg('Project Name/ID')} name="projectName"
								   value="${p.projectName}" ?print="${this.print}"></personalise-field>
				<personalise-field label=${msg('Project Address')} name="projectAddress"
								   value="${p.projectAddress}" ?print="${this.print}"></personalise-field>
				<personalise-field label=${msg('Note')} name="note" value="${p.note}" isTextArea
								   ?print="${this.print}"></personalise-field>
			</div>
		`;
	}
}
